<template>
  <div class="home">
    <Sidebar />
    <div id="main-content" :class="expanded ? 'squish' : ''">
      <Nav />
      <ProductTable />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';
import Sidebar from '@/components/Sidebar.vue';
import Nav from '@/components/Nav.vue';
import ProductTable from '@/components/ProductTable.vue';

export default {
  name: 'Home',
  components: {
    Sidebar,
    Nav,
    ProductTable
  },
  computed: {
    ...mapGetters(['expanded'])
  }
};
</script>

<style lang="scss">
#main-content {
  transition: margin-left 0.5s;
  margin-left: 50px;
  &.squish {
    margin-left: 250px;
  }
}
</style>
